import type { InquiryTemplateEditorFormData } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/types';
import Action from 'lib/interfaces/Action';

export type InquiryTemplateActions =
  | Action<InquiryTemplateActionType.SetFormValues, SetFormValuesPayload>
  | Action<InquiryTemplateActionType.ClearFormValues>;

export enum InquiryTemplateActionType {
  // undo/redo
  ClearFormValues = 'inquiry-template/CLEAR_FORM_VALUES',
  SetFormValues = 'inquiry-template/SET_FORM_VALUES',
}

export function clearFormValues(): Action<InquiryTemplateActionType.ClearFormValues> {
  return {
    type: InquiryTemplateActionType.ClearFormValues,
  };
}

interface SetFormValuesPayload {
  values: InquiryTemplateEditorFormData;
}

export function setFormValues(
  values: InquiryTemplateEditorFormData,
): Action<InquiryTemplateActionType.SetFormValues, SetFormValuesPayload> {
  return { payload: { values }, type: InquiryTemplateActionType.SetFormValues };
}
